// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    aws_project_region: 'eu-west-2',
    aws_cognito_identity_pool_id: 'eu-west-2:e03342e3-6339-4294-bd13-ee723a6d442b',
    aws_cognito_region: 'eu-west-2',
    aws_user_pools_id: 'eu-west-2_maVCGQ0Xv',
    aws_user_pools_web_client_id: '3o3ujjp16tvkllbsqe3nii9p11',
    oauth: {
        domain: 'bs-suppliers-stg.auth.eu-west-2.amazoncognito.com',
        scope: [
            'phone',
            'email',
            'openid',
            'profile',
            'aws.cognito.signin.user.admin',
        ],
        redirectSignIn: 'http://localhost:3000/callback/',
        redirectSignOut: 'http://localhost:3000/callback/',
        responseType: 'token',
    },
    federationTarget: 'COGNITO_USER_POOLS',
    aws_appsync_graphqlEndpoint: 'https://amwusmq4bvc6lhynqztfhoxvju.appsync-api.eu-west-2.amazonaws.com/graphql',
    aws_appsync_region: 'eu-west-2',
    aws_appsync_authenticationType: 'AMAZON_COGNITO_USER_POOLS',
}


export default awsmobile
